import validateIBAN from '@/helpers/validateIBAN'

export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return validateIBAN(value)
  }
}
